import { createApp } from 'vue';

const app = createApp({});

// you can set only in production env show the error-log
if (process.env.NODE_ENV === 'production') {
  app.config.errorHandler = function (err, vm, info) {
    // 使用 nextTick 确保在下一个事件循环中执行
    Vue.nextTick(() => {
      console.error('Global error handler:', err, info);
      // 这里可以添加错误上报逻辑
      // reportErrorToServer(err, vm, info);
    });
  };
}
